"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingSchema = void 0;
const zod_1 = require("zod");
// Схема для Meeting
exports.meetingSchema = zod_1.z.object({
  id: zod_1.z.string(),
  title: zod_1.z.string().optional(),
  description: zod_1.z.string().optional(),
  teacher_id: zod_1.z.string().optional(),
  student_id: zod_1.z.string().optional(),
  subject_id: zod_1.z.number().optional(),
  language_id: zod_1.z.number().optional(),
  start_time: zod_1.z.string().optional(),
  end_time: zod_1.z.string().optional(),
  duration: zod_1.z.number().optional(),
  status: zod_1.z.string().optional(),
  price: zod_1.z.number().optional(),
  currency: zod_1.z.string().optional(),
  is_paid: zod_1.z.boolean().optional(),
  is_confirmed: zod_1.z.boolean().optional(),
  is_canceled: zod_1.z.boolean().optional(),
  is_completed: zod_1.z.boolean().optional(),
  meeting_url: zod_1.z.string().optional(),
  created_at: zod_1.z.string().optional(),
  updated_at: zod_1.z.string().optional()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.any()); // для других полей
